import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { ModalRef, ModalService } from '@vinnova/ui';
import {
  AnalyticsLoaderService,
  ConsentTypes,
  CookieConsentService,
} from '@vinnova/utilities';

@Component({
  selector: 'lib-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrls: ['./cookie-banner.component.scss'],
  standalone: false,
})
export class CookieBannerComponent implements AfterViewInit {
  cookieConsentModalRef: ModalRef;
  showCookieSettings = false;
  showRequiredCookiesText = false;
  showAnalyticsCookiesText = false;
  hasAnalyticsConsent = true;
  @ViewChild('cookieConsentModal') cookieConsentModal;

  constructor(
    private modalService: ModalService,
    private cookieConsentService: CookieConsentService,
    protected analyticsLoaderService: AnalyticsLoaderService,
  ) {}

  ngAfterViewInit() {
    if (!this.cookieConsentService.hasAnyConsent()) {
      this.openCookieConsentModal();
    }
  }
  openCookieConsentModal() {
    this.cookieConsentModalRef = this.modalService.show(
      this.cookieConsentModal,
      {
        backdrop: 'static',
        keyboard: false,
        class: 'modal-lg',
      },
    );
  }

  acceptCookies() {
    this.cookieConsentService.setConsent(
      this.hasAnalyticsConsent ? ConsentTypes.Analytics : ConsentTypes.Required,
    );
    this.analyticsLoaderService.setAnalyticsConsent(this.hasAnalyticsConsent);
    this.cookieConsentModalRef.hide();
  }

  openCookieSettings() {
    this.showCookieSettings = true;
  }
}
